import { WorkBook } from "xlsx-js-style";
import * as XLSX from 'xlsx-js-style';
import { getPreparedData } from "./mapping";
import { fitToColumn } from "src/app/domain/excel/templates/financial-statement/utils";
import { Overview } from "src/app/domain/organization/components/org-pp-funds-overview/org-pp-funds-overview.component";
import { ExcelTemplate } from "src/app/domain/excel/interfaces";

export class PpByFundTemplate implements ExcelTemplate {
  export(data: Overview[]): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(exportExcelData): XLSX.WorkSheet {
    const headers = this.getHeaders();
    const preparedData = getPreparedData(exportExcelData, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    return (sheet);
  }

  private getHeaders(): string[] {
    return ['Fund', 'Period', 'Investment', 'Fair value', 'Gain/Loss', 'MOIC', 'IRR', 'Holding', 'Company value'];
  }

}
